import { render, staticRenderFns } from "./cglshgz12026.vue?vue&type=template&id=15f20773&scoped=true"
import script from "./cglshgz12026.vue?vue&type=script&lang=js"
export * from "./cglshgz12026.vue?vue&type=script&lang=js"
import style0 from "./cglshgz12026.vue?vue&type=style&index=0&id=15f20773&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f20773",
  null
  
)

export default component.exports